module.exports = __webpack_public_path__ + "img/rollout-icon.1e76c5ff.svg";